import { render, staticRenderFns } from "./LocalMaterial.vue?vue&type=template&id=7cb5a72d"
import script from "./LocalMaterial.vue?vue&type=script&lang=js"
export * from "./LocalMaterial.vue?vue&type=script&lang=js"
import style0 from "./LocalMaterial.vue?vue&type=style&index=0&id=7cb5a72d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports